import { getTierClassification } from '../utils/tierClassification';

function getCookie(name) {
  let cookie = {}
  document.cookie.split(';').forEach(function (el) {
    let [k, v] = el.split('=')
    cookie[k.trim()] = v
  })
  return cookie[name]
}

export function getRDTRKCookie() {
  const cookie = getCookie('rdtrk')
  if (!cookie) {
    console.log("No rdtrk cookie found")
    return { id: '' }
  }
  
  const decodedCookie = decodeURIComponent(cookie)
  let cookieObject
  try {
    cookieObject = JSON.parse(decodedCookie)
  } catch(e){
    console.log("invalid cookie", e)
    cookieObject = { id: '' }
  }

  return cookieObject || { id: '' }
}

export const buildPayload = (resultData, formData, destination = "RD") => {
  const RDID = getRDTRKCookie() || 'anonymous_user_' + Date.now()

  // Calculate tier classification based on total investment (patrimonio)
  const tier = getTierClassification(resultData.totalInvestment);

  const shared = {
    'conversion_identifier': 'fee_simulator_conversion',
    'name': formData.name,
    'email': formData.email,
    'personal_phone': formData.phone || '',
    'cf_economia_total_10_anos': resultData.totalEconomy ? resultData.totalEconomy.toString() : "0",
    'cf_economia_anual': resultData.yearlyEconomy ? resultData.yearlyEconomy.toString() : "0",
    'cf_taxa_tradicional_anual': resultData.traditionalFee ? resultData.traditionalFee.toString() : "0",
    'cf_taxa_monefica_anual': resultData.moneficaFee ? resultData.moneficaFee.toString() : "0",
    'cf_valor_total_investido': resultData.totalInvestment ? resultData.totalInvestment.toString() : "0",
    'cf_tier': tier,
    'client_tracking_id': RDID.id,
    'traffic_source': getCookie('__trf.src') || 'direct',
  }

  if(destination === "RD"){
    return shared
  }

  return {
    people: {
      "$email": formData.email,
      "USER_ID": RDID
    },
    track: {
      ...shared,
      "$email": formData.email
    }
  }
}

const buildBody = (payload) => {
  return {
    'event_type': 'CONVERSION',
    'event_family': 'CDP',
    payload
  }
}

const headers = new Headers()
headers.append('Content-Type', 'application/json')

// Função para testar a integração
export const testIntegration = (email = 'teste@monefica.com.br') => {
  const testData = {
    totalEconomy: 50000,
    yearlyEconomy: 5000,
    traditionalFee: 10000,
    moneficaFee: 5000,
    totalInvestment: 1000000
  }
  
  const testForm = {
    name: 'Teste Usuario',
    email: email,
    phone: '11999999999'
  }
  
  console.log('Executando teste de integração...')
  return integrate(testData, testForm)
}

export const integrate = (resultData, formData) => {
  console.log('=== INICIANDO INTEGRAÇÃO ===')
  console.log('Dados do resultado:', resultData)
  console.log('Dados do formulário:', formData)
  
  // Validar dados obrigatórios
  if (!formData.email || !formData.name) {
    const error = new Error('Email e nome são obrigatórios')
    console.error(error)
    throw error
  }
  

  if(window.fbq){
    try {
      window.fbq('trackCustom', 'conversion-lp', {lp: 'fee-fixo'})
      console.log('✅ Facebook Pixel enviado com sucesso')
    } catch (e) {
      console.log('❌ Erro no Facebook Pixel:', e)
    }
  } else {
    console.log('⚠️ Facebook Pixel não disponível')
  }

  const RDpayload = buildPayload(resultData, formData, "RD")
  const body = buildBody(RDpayload)
  
  console.log('=== PAYLOAD PARA RD STATION ===')
  console.log(JSON.stringify(body, null, 2))
  console.log('===========================')

  return fetch('https://api.rd.services/platform/conversions?api_key=8d81950c6b78452601cc7f796f45411a', {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  })
  .then(response => {
    console.log('RD Station Response Status:', response.status)
    console.log('Response Headers:', [...response.headers.entries()])
    
    // Verificar se a resposta tem conteúdo
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      return response.json().then(data => {
        console.log('✅ RD Station Response:', data)
        if (!response.ok) {
          throw new Error(`RD Station API error: ${response.status} - ${JSON.stringify(data)}`)
        }
        return data
      })
    } else {
      return response.text().then(text => {
        console.log('RD Station Response (text):', text)
        if (!response.ok) {
          throw new Error(`RD Station API error: ${response.status} - ${text}`)
        }
        return { success: true, response: text }
      })
    }
  })
  .catch(error => {
    console.error('❌ Erro na integração com RD Station:', error)
    throw error
  })
}

// Expor função de teste globalmente para debug
if (typeof window !== 'undefined') {
  window.testRDIntegration = testIntegration
} 